import { FormControl } from '../FormControl';
import { Input } from './Input';
export function InputTextField({
  label,
  labelStyle,
  helperText,
  helperStyle,
  error,
  outerStyle,
  infoText,
  ...other
}) {
  return <FormControl label={label} labelStyle={labelStyle} helperText={helperText} helperStyle={helperStyle} error={error} outerStyle={outerStyle} infoText={infoText}>
			<Input error={error} {...other} />
		</FormControl>;
}